<template>
    <div :class="{
      navbar: true,
      transparent: transparent,
    }">
      <router-link class="company-name" to="/">
        <div style="padding: 0 0 9px 0">G&S Components<span> s.r.o.</span></div>
      </router-link>
      <div class="routes">
        <router-link v-for="(name, route) in routerLinks" :key="route" class="menu-item" :to="route">
          <div class="route-name">{{ loc.menu[name] }}</div>
        </router-link>
      </div>
    </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    routerLinks: { type: Object },
    transparent: { type: Boolean },
  },
}
</script>

<style lang="less" scoped>
  @import "../styles/colors";
  @import "../styles/fonts";

  .menu-item {
    display: inline-block;
  }
  .navbar {
    position: fixed;
    height: 60px;
    width: 100%;
    top: 0px;
    background-color: @blue;
    z-index: 10;
  }
  .routes {
    display: flex;
    margin: 0 auto 0 auto;
    height: 100%;
    justify-content: center;
  }
  .transparent {
    background-color: rgba(0,0,0,0);
  }
  .menu-item {
    width: fit-content;
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    margin: 0px;
    padding: 0px 8px 0px 8px !important;
    text-decoration: none;
    font-size: 18px;
  }
  .company-name {
    font-size: 32px;
    position: absolute;
    float: left;
    color: @base;
    display: flex;
    margin: 0 30px 0 30px;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    font-family: @title;
    text-decoration: none;
  }
  .company-name span{
    font-size: 20px;
    padding: 0px;
  }
</style>
